module.exports = __webpack_public_path__ + "img/ynyd.4e94d449.png";